// Renderização incremental da lista de lojas.
const LIMITE_PASSO = 50;
const MARGEM_PREFETCH = '200px';

export default {
  data () {
    return {
      limite: LIMITE_PASSO,
    };
  },
  computed: {
    estabelecimentosVisiveis () {
      return this.estabelecimentos.slice(0, this.limite);
    },
    totalRestante () {
      return this.estabelecimentos.length - this.estabelecimentosVisiveis.length;
    },
    proximoPasso () {
      return this.totalRestante < LIMITE_PASSO ? this.totalRestante : LIMITE_PASSO;
    },
  },
  mounted () {
    // o conteúdo do v-dialog não é lazy: a sentinela já existe no mount
    this.observarSentinela();
  },
  updated () {
    this.observarSentinela();
  },
  beforeDestroy () {
    this.desconectarSentinela();
  },
  methods: {
    resetLimite () {
      this.limite = LIMITE_PASSO;
    },
    mostrarMais () {
      if (this.totalRestante <= 0) { return; }
      this.limite += LIMITE_PASSO;
    },
    observarSentinela () {
      const ref = this.$refs.sentinela;
      const alvo = Array.isArray(ref) ? ref[0] : ref;
      const node = alvo && alvo.$el ? alvo.$el : alvo;

      // sem sentinela = lista inteira já renderizada
      if (!node) {
        this.desconectarSentinela();
        return;
      }

      // mesma sentinela: o IntersectionObserver só dispara na transição para
      // visível, então quando o passo anterior veio dele é preciso reobservar —
      // senão o carregamento para com a sentinela ainda na tela (viewport alta,
      // lista curta, itens ocultos por v-if).
      if (node === this.sentinelaNode) {
        if (this.reobservarSentinela && this.sentinelaObserver) {
          this.reobservarSentinela = false;
          this.sentinelaObserver.unobserve(node);
          this.sentinelaObserver.observe(node);
        }
        return;
      }

      if (typeof window === 'undefined' || !window.IntersectionObserver) { return; }

      this.desconectarSentinela();
      this.sentinelaNode = node;
      this.sentinelaObserver = new window.IntersectionObserver(entries => {
        // o dialog fechado fica display:none, então não intersecta
        if (entries.some(entry => entry.isIntersecting)) {
          this.reobservarSentinela = true;
          this.mostrarMais();
        }
      }, { rootMargin: MARGEM_PREFETCH });
      this.sentinelaObserver.observe(node);
    },
    desconectarSentinela () {
      if (this.sentinelaObserver) {
        this.sentinelaObserver.disconnect();
        this.sentinelaObserver = null;
      }
      this.sentinelaNode = null;
      this.reobservarSentinela = false;
    },
  },
};
